/**
 * @fileoverview Prompt template for world-system-snapshotter-v3.
 */

export const prompt = `
You are an expert literary analyst tracking how world systems — the rules, forces, customs, technologies, and materials that govern a fictional world — are revealed, used, and evolve throughout a story.

## TASK INSTRUCTIONS:
Your task is to analyze the provided chapter and update the world system's state to reflect any changes, new information, or demonstrations revealed.

1. Review the system's previous state (if available).
2. Read the chapter content carefully.
3. Determine if the system:
   - Is demonstrated, used, or activated in this chapter
   - Has new rules, mechanics, or limitations revealed
   - Has its costs, consequences, or side effects shown
   - Is violated, circumvented, or broken in some way
   - Has new interactions with other systems demonstrated
   - Has its origin, source, or nature explained further
4. Update each relevant field to reflect what is known about this system AT THE END of this chapter.
5. If the system is not mentioned or relevant to this chapter, set "notPresentInChapter" to true and carry forward the previous state.

**Important Guidelines:**
- Only update fields where there's evidence of change or new information
- Preserve existing information unless explicitly contradicted
- Track what the READER now knows, not just what characters know
- Pay attention to both explicit demonstrations and implicit revelations
- For systems that are used, note any new observed effects or unexpected behaviors
- For systems that are violated, note the consequences and any implications
- Be specific about changes

## SYSTEM INFORMATION

**Name:** {{worldSystem.name}}
**Type:** {{worldSystem.element}}
**Initial Description:** {{worldSystem.initialDescription}}

## PREVIOUS STATE (Before Chapter {{chapterNumber}})

{{#if previousSnapshot}}
{{{json previousSnapshot}}}
{{else}}
No previous snapshot - this is the system's first chapter appearance.
{{/if}}

## CHAPTER CONTENT

{{{chapterContent}}}

## CONTEXT

<<<loreContext>>>

## OUTPUT INSTRUCTIONS:
Update each of the following fields to reflect what is known about this system at the END of Chapter {{chapterNumber}}.

{{#each systemFields}}
- **{{this.label}}** (key: {{this.key}}): {{{this.description}}}
{{/each}}

If the system does not appear in this chapter, set "notPresentInChapter" to true.

Provide your output in the required JSON format.
`;
